import axios from "axios";
import _ from "lodash";
import moment from 'moment'

function showCycleResult(cycle){
    if(cycle.show_challenge_result == 'after_date' && moment().isAfter(cycle.release_challenge_result_at)){
      return true
    }
    if(cycle.show_challenge_result == 'after_cycle' && cycle.is_finished){
      return true
    }
    if(cycle.show_challenge_result == 'after_finish' && cycle.challenge && cycle.challenge.finished_at){
      return true
    }
    return false
}

export default {
  state: {
    isLoadingCycles: false,
    isLoadingCycle: false,
    list: [],
    current: null,
  },
  actions: {
    getCycles({ commit, state, rootState }, params = { filters: '' , set_current_cycle: true} ) {
      state.isLoadingCycles = true;
      return axios.get(`/api/v1/student/cycle?year=${rootState.selectedYear}${params.filters}`)
        .then(response => {

          let  { data : { data : cycles } } = response

          commit("SET_CYCLES", cycles.map(cycle => {

            cycle.show_result = showCycleResult(cycle)

            cycle.is_online = cycle.challenge_type == 'online'
            
            cycle.begin_formatted = cycle.begin ? moment(cycle.begin).format('DD/MM/YYYY') : cycle.begin
            cycle.begin_formatted_day_month = cycle.begin ? moment(cycle.begin).format('DD/MM') : cycle.begin
            cycle.begin_formatted_with_hours = cycle.begin ? moment(cycle.begin).format('DD/MM/YYYY hh:mm') : cycle.begin

            cycle.end_formatted = cycle.end ? moment(cycle.end).format('DD/MM/YYYY '): cycle.end
            cycle.end_formatted_day_month = cycle.end ? moment(cycle.end).format('DD/MM'): cycle.end
            cycle.end_formatted_with_hours = cycle.end ? moment(cycle.end).format('DD/MM/YYYY hh:mm'): cycle.end

            cycle.begin_challenge_apply_formatted = cycle.begin_challenge_apply ? moment(cycle.begin_challenge_apply).format('DD/MM/YYYY') : cycle.begin_challenge_apply
            cycle.begin_challenge_apply_formatted_with_hours = cycle.begin_challenge_apply ? moment(cycle.begin_challenge_apply).format('DD/MM/YYYY hh:mm') : cycle.begin_challenge_apply

            cycle.end_challenge_apply_formatted = cycle.end_challenge_apply ? moment(cycle.end_challenge_apply).format('DD/MM/YYYY') : cycle.end_challenge_apply
            cycle.end_challenge_apply_formatted_with_hours = cycle.end_challenge_apply ? moment(cycle.end_challenge_apply).format('DD/MM/YYYY hh:mm') : cycle.end_challenge_apply

            cycle.has_all_modules_defined  = cycle.modules.length == cycle.expected_modules_qty;
            cycle.cant_start_module = (!cycle.is_finished && !cycle.has_all_modules_defined)

            cycle.modules = cycle.modules.map(m=> {
              return {
                ...m,
                subject: m.block ? m.block.trail : m.subject,

              }
            })
            return cycle
          }));
          const current_cycle = rootState.selectedYear != rootState.currentYear ? cycles.at(-1) : cycles.find(c => c.is_current);
          if(params.set_current_cycle){
            commit("SET_CYCLE", current_cycle);
          }
          return response;
        })
        .finally(() => state.isLoadingCycles = false);
    },
  },
  mutations: {
    SET_CYCLES(state, payload) {
      state.list = payload;
    },
    SET_CYCLE(state, payload) {
      state.current = payload;
    },
  },
  getters: {
    cycles: state => state.list,
    all_modules: (state) => {
      let ar = [];
      state.list.forEach(c => {
        c.modules.forEach(m => ar.push(m))
      })
      return ar;
    },
    count_challenges: state => state.list.map(c=> c.challenge ? 1 : 0).reduce((a,b) => a + b),
    selectedCycle : (state) => state.current,
    finished_modules: (getters) => getters.all_modules.filter(m => m.finished_at),
    current_cycle : (state,rootState) => rootState.selectedYear != rootState.currentYear ? state.list.at(-1) : state.list.find(c => c.is_current),
    currentCycle : (state,getters) => getters.current_cycle,
    currentCycleOrder: (state, getters) => getters.current_cycle.order,

    /** Módulos dos ciclos */
    unfinishedModulesOnCurrentCycle: (state, getters) => getters.current_cycle.has_all_modules_defined ?  getters.current_cycle.modules.filter(m=> !m.finished_at) : [],
    hasUnfinishedModulesOnCurrentCycle: (state, getters) => getters.current_cycle.has_all_modules_defined ? getters.current_cycle.modules.filter(m=> !m.finished_at).length > 0 : false,
    firstUnfinishedModulesOnCurrentCycle: (state, getters) => getters.hasUnfinishedModulesOnCurrentCycle ? getters.unfinishedModulesOnCurrentCycle[0] : null,
    currentCyclesHasUnfinishedModules: (state, getters) => getters.current_cycle.modules.filter(m=> !m.finished_at).length > 0,
    currentCycleHasModules: (state, getters) => (getters.current_cycle.count_modules - getters.current_cycle.count_themes) > 0,
    currentCycleIsFinished: (state, getters) => getters.current_cycle.is_finished,
    currentCycleHasAllModuleCompleted: (state, getters) => getters.currentCycleHasModules && getters.current_cycle.modules.filter(c=>!c.finished_at).length === 0 ,

    hasChallengeRunning: (state, getters) => getters.current_cycle.challenge && getters.current_cycle.challenge.started_at && !getters.current_cycle.challenge.finished_at,

    selectedCycleHasUnfinishedModules: (state, getters) => getters.selectedCycle.modules.filter(m=> !m.completed).length > 0,
    selectedCycleHasModules: (state, getters) => (getters.selectedCycle.count_modules - getters.selectedCycle.count_themes) > 0,
    selectedCycleChallengePercentage: (state, getters) => getters.selectedCycle.challenge && getters.selectedCycle.challenge.finished_at ? 100 : 0 ,
    selectedCycleProgress : (state, getters) => Number(Number(getters.selectedCycle.content_progress * 0.75) + Number(getters.selectedCycleChallengePercentage * 0.25)),
    selectedCycleHasChallenge: (state, getters) => getters.selectedCycle.challenge,
    selectedCycleChallenge : (state, getters) => getters.selectedCycleHasChallenge ? getters.selectedCycle.challenge : null,

    completedModulesWithUncompletedContents : (state) => _.concat(...state.list.filter(l=>l.modules.length > 0).map( l => l.modules.filter(m=>m.completed && m.count_uncompleted_contents>0))),
    cycles_performances : (state) => state.list.map(c=> c.performance),
    finishedCycles : (state) => state.list.filter(c=> c.is_finished),
    higher_cycle_performance : (state, getters) => _.orderBy(getters.finishedCycles.filter(c=>c.order>0), ['performance'], ['desc'])[0],
    lower_cycle_performance : (state, getters) => _.orderBy(getters.finishedCycles.filter(c=>c.order>0), ['performance'], ['asc'])[0],
    avg_cycle_performance : (state, getters) => _.mean(getters.finishedCycles.filter(c=>c.order>0).map(c=>c.performance)),
    high_performance_modules: (state, getters) => getters.all_modules.filter(m=>m.type!='pre_cycle').filter(m=>m.high_performance && m.challenge_id),
    low_performance_modules: (state, getters) => getters.all_modules.filter(m=>m.type!='pre_cycle').filter(m=>m.low_performance && m.challenge_id),
  }
}
